var _path, _path2, _g, _g2, _path3, _path4, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2920_5975)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.519 17.4017C8.97836 19.5863 8.82673 22.7504 10.4293 26.3763C13.6344 33.628 22.6424 39.9806 30.5492 40.5652C34.5027 40.8575 37.4323 39.6525 38.9729 37.4679L41.1802 34.3379C42.7208 32.1533 42.8724 28.9892 41.2699 25.3633C38.0648 18.1116 29.0568 11.759 21.1499 11.1744C17.1965 10.8821 14.2669 12.0872 12.7262 14.2718L10.519 17.4017Z",
    fill: "url(#paint0_linear_2920_5975)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2920_5975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 11,
    width: 34,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.519 17.4017C8.97836 19.5863 8.82673 22.7504 10.4293 26.3763C13.6344 33.628 22.6424 39.9806 30.5492 40.5652C34.5027 40.8575 37.4323 39.6525 38.9729 37.4679L41.1802 34.3379C42.7208 32.1533 42.8724 28.9892 41.2699 25.3633C38.0648 18.1116 29.0568 11.759 21.1499 11.1744C17.1965 10.8821 14.2669 12.0872 12.7262 14.2718L10.519 17.4017Z",
    fill: "url(#paint1_linear_2920_5975)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2920_5975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2064 23.2972L29.3199 28.3137L19.7162 29.849L16.1043 34.9707L10.5961 27.6778L14.208 22.5561L22.2064 23.2972Z",
    fill: "#ED9A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5195 28.0292L23.8288 24.016L25.8912 33.7784L22.2793 38.9001L28.5046 40.9471L32.3172 35.5408L29.5195 28.0292Z",
    fill: "#FFD454"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2920_5975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.26063,
    cy: 9.26063,
    r: 9.26063,
    transform: "matrix(0.995894 0.0905269 0.419606 0.907706 13.9297 14.9443)",
    fill: "#FFA81E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9844 25.183C42.9696 31.6406 39.646 36.3534 32.5611 35.7093C25.4762 35.0653 17.3127 29.3083 14.3276 22.8508C11.3425 16.3932 14.666 11.6804 21.7509 12.3245C28.8359 12.9685 36.9993 18.7254 39.9844 25.183Z",
    stroke: "url(#paint2_linear_2920_5975)",
    strokeWidth: 0.696355
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.374 24.8548C38.5189 29.4946 36.1308 32.8809 31.0402 32.4182C25.9495 31.9554 20.0839 27.8189 17.939 23.179C15.7941 18.5391 18.1822 15.1529 23.2728 15.6156C28.3635 16.0784 34.2291 20.2149 36.374 24.8548Z",
    stroke: "url(#paint3_linear_2920_5975)",
    strokeWidth: 0.696355
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2920_5975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1502 29.7107L27.0323 29.0857L26.0559 23.437L23.3349 22.6341L23.021 20.8184L30.5808 23.0494L30.8946 24.865L28.1737 24.0621L29.1502 29.7107ZM22.5328 17.9941L30.0925 20.2251L30.4064 22.0407L22.8467 19.8098L22.5328 17.9941Z",
    fill: "#FFD454"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2920_5975",
    x: 7.29297,
    y: 9.1311,
    width: 37.1133,
    height: 33.4773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2920_5975"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2920_5975",
    x: 17.0273,
    y: 15.7402,
    width: 20.0195,
    height: 16.8967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.04453
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.573446 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2920_5975"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2920_5975",
    x: 22.5312,
    y: 17.9941,
    width: 9.33984,
    height: 13.0418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.522266
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2920_5975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2920_5975",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.348177
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2920_5975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2920_5975",
    x1: 43.8967,
    y1: 19.4223,
    x2: 6.92276,
    y2: 29.5618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2920_5975",
    x1: 43.8967,
    y1: 19.4223,
    x2: 6.92276,
    y2: 29.5618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2920_5975",
    x1: 28.4681,
    y1: 9.55192,
    x2: 13.4525,
    y2: 29.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2920_5975",
    x1: 28.109,
    y1: 13.5163,
    x2: 17.2087,
    y2: 27.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/Coin1.62e2d3e819a0e88c8783e522cf710730.svg";
export { ForwardRef as ReactComponent };